import { viatorSearchUrl } from './affiliateLinks';

export const ALL_TRIP_DESTINATIONS = 'all';

export function mapViatorActivityToPlace(activity) {
  return {
    place_id: activity.id || `viator_${Math.random()}`,
    name: activity.title,
    rating: activity.rating,
    user_ratings_total: activity.reviewCount || 0,
    price_level: 0,
    price: activity.price,
    duration: activity.duration,
    photos: activity.image ? [{ getUrl: () => activity.image }] : [],
    vicinity: activity.description,
    types: ['tourist_attraction'],
    category: 'attractions',
    url: activity.url,
    source: 'viator',
    kind: activity.kind || 'product',
    freeCancellation: Boolean(activity.freeCancellation),
    destinationName: activity.destinationName || '',
  };
}

export function tripLocationNames(locations = []) {
  return [...new Set(
    (locations || [])
      .map((location) => String(location?.name || location || '').trim())
      .filter(Boolean)
  )];
}

export function resolveViatorSearchLocations(locations, selected = ALL_TRIP_DESTINATIONS) {
  const names = tripLocationNames(locations);
  if (!names.length) return [];
  if (selected && selected !== ALL_TRIP_DESTINATIONS && names.includes(selected)) {
    return [selected];
  }
  return names;
}

export function mergeViatorSearchResults(groups, { limit = 24 } = {}) {
  const seen = new Set();
  const merged = [];
  (groups || []).forEach((group) => {
    const location = String(group?.location || '').trim();
    (group?.activities || []).forEach((activity) => {
      const place = mapViatorActivityToPlace({ ...activity, destinationName: location });
      if (!place.place_id || seen.has(place.place_id)) return;
      seen.add(place.place_id);
      merged.push(place);
    });
  });
  return merged.slice(0, limit);
}

export function buildViatorAreaQuery(locationName, extraQuery = '') {
  const location = String(locationName || '').trim();
  const extra = String(extraQuery || '').trim();
  if (extra && location) return `${extra} ${location}`;
  return extra || location;
}

export function viatorAreaSearchUrl(locationName, extraQuery = '') {
  return viatorSearchUrl(buildViatorAreaQuery(locationName, extraQuery));
}

export function viatorMultiAreaSearchUrl(locations, extraQuery = '', selected = ALL_TRIP_DESTINATIONS) {
  const targets = resolveViatorSearchLocations(locations, selected);
  if (!targets.length) return viatorSearchUrl(extraQuery);
  if (targets.length === 1) return viatorAreaSearchUrl(targets[0], extraQuery);
  return viatorSearchUrl(buildViatorAreaQuery(targets.join(' '), extraQuery));
}
